import React, { useEffect, useState } from "react";
import { Select, Button, Modal, Input, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { addLeadStatus, fetchLeadStatus } from "../leadThunk";

// Shared "pick a lead status, or add a new one inline" control — same
// Select + dropdownRender "+ Add Status" + Modal convention as the one in
// LeadDrawer.jsx, extracted so the Call tab and Task Details don't each
// reimplement the add-new-status modal/thunk wiring themselves.
const LeadStatusSelect = ({ value, onChange, disabled, placeholder = "Status" }) => {
  const dispatch = useDispatch();
  const statusList = useSelector((s) => s.leads.statusList);

  const [statusModal, setStatusModal] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [statusColor, setStatusColor] = useState("blue");
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    if (!statusList?.length) dispatch(fetchLeadStatus());
  }, [statusList?.length, dispatch]);

  const handleAdd = async () => {
    if (!newStatus.trim()) return message.warning("Enter status name");
    setAdding(true);
    try {
      const res = await dispatch(addLeadStatus({ name: newStatus, color: statusColor })).unwrap();
      onChange?.(res.id);
      await dispatch(fetchLeadStatus());
      message.success("Status added");
      setStatusModal(false);
      setNewStatus("");
      setStatusColor("blue");
    } catch (err) {
      const errMsg = typeof err === "string" ? err : err?.message || err?.msg || "Failed";
      message.error(errMsg.toLowerCase().includes("exist") ? "Status already exists" : errMsg);
    } finally {
      setAdding(false);
    }
  };

  return (
    <>
      <Select
        style={{ width: "100%" }}
        placeholder={placeholder}
        value={value || undefined}
        onChange={onChange}
        disabled={disabled}
        options={(statusList || []).map((s) => ({ label: s.name, value: s.id }))}
        dropdownRender={(menu) => (
          <>
            {menu}
            <div style={{ padding: 8 }}>
              <Button type="link" onClick={() => setStatusModal(true)}>
                + Add Status
              </Button>
            </div>
          </>
        )}
      />

      <Modal
        title="Add New Status"
        open={statusModal}
        onCancel={() => {
          setStatusModal(false);
          setNewStatus("");
          setStatusColor("blue");
        }}
        onOk={handleAdd}
        confirmLoading={adding}
        className="crm-modal-responsive"
      >
        <Input
          placeholder="Status name"
          value={newStatus}
          onChange={(e) => setNewStatus(e.target.value)}
          style={{ marginBottom: 10 }}
        />
        <Select
          value={statusColor}
          onChange={setStatusColor}
          style={{ width: "100%" }}
          options={[
            { label: "Blue", value: "blue" },
            { label: "Green", value: "green" },
            { label: "Red", value: "red" },
            { label: "Orange", value: "orange" },
            { label: "Purple", value: "purple" },
          ]}
        />
      </Modal>
    </>
  );
};

export default LeadStatusSelect;
